import getPieveAuthToken from '@/lib/auth/getPieveAuthToken.js';
import upsertThreadOptimistic from '@/redux/actions/pieveActions/upsertThreadOptimistic.js';
import createRequestFailure from '@/redux/requests/lib/createRequestFailure.js';
import markThreadOpened from '@/redux/requests/threads/markThreadOpened.js';

const persistThreadOpenedState = ({ threadId, openedAt = undefined } = {}) => {
  return async (dispatch) => {
    const normalizedThreadId = String(threadId || '').trim();
    const normalizedOpenedAt = String(openedAt || '').trim();

    if (!normalizedThreadId || !normalizedOpenedAt) {
      return createRequestFailure({ message: 'threadId and openedAt are required' });
    }

    const authToken = await getPieveAuthToken();
    const openRes = await markThreadOpened({
      threadId: normalizedThreadId,
      openedAt: normalizedOpenedAt,
      authToken
    });

    if (openRes?.success) {
      dispatch(
        upsertThreadOptimistic({
          thread: {
            id: normalizedThreadId,
            lastOpenedAt: openRes?.data?.lastOpenedAt || normalizedOpenedAt
          }
        })
      );
    }

    return openRes;
  };
};

export default persistThreadOpenedState;
